
import { CityPageTemplate } from '@/components/seo/CityPageTemplate';
import { Laptop, Users, DollarSign } from 'lucide-react';

const SanFranciscoPage = () => {
  return (
    <CityPageTemplate
      city="San Francisco"
      state="California"
      stateAbbr="CA"
      population="870,000+"
      majorIndustries={["technology", "financial services", "biotechnology", "healthcare", "tourism"]}
      businessChallenges={[
        "Extremely high cost of living and wages",
        "Intense competition for tech talent",
        "Complex San Francisco employment ordinances", 
        "High commercial real estate costs",
        "Strict paid sick leave and scheduling laws"
      ]}
      peoSolutions={[
        "Competitive benefits to attract top talent",
        "Expert guidance on SF employment ordinances",
        "Cost-effective HR infrastructure for startups",
        "Professional payroll and equity compensation",
        "Comprehensive risk management services"
      ]}
      localBusinessTypes={[
        { name: "Technology", description: "Startups, SaaS companies, fintech" },
        { name: "Biotech", description: "Research, pharmaceuticals, medical devices" },
        { name: "Financial Services", description: "Banking, investment, insurance" },
        { name: "Professional Services", description: "Consulting, legal, accounting" }
      ]}
      metaDescription="Find the best PEOs in San Francisco with The PEO App. Compare quotes from top SF Professional Employer Organizations offering specialized HR solutions for tech companies and Bay Area businesses."
      keyFeatures={[
        {
          icon: Laptop,
          title: "Tech Startup Expertise",
          description: "Specialized PEO services for San Francisco's thriving startup ecosystem with equity compensation and rapid scaling support."
        },
        {
          icon: DollarSign,
          title: "Competitive Benefits",
          description: "Access to premium benefits packages needed to attract and retain top talent in SF's competitive market."
        },
        {
          icon: Users,
          title: "SF Ordinance Compliance",
          description: "Expert navigation of San Francisco's unique employment laws including Fair Chance, Surveillance, and scheduling ordinances."
        }
      ]}
    />
  );
};

export default SanFranciscoPage;
